import React, { useState } from 'react';
import { Check, Phone, Heart, Shield, Clock, Users, Menu, X } from 'lucide-react';
import Logo from "../assets/Logo.jpeg"
import Location from "../components/Location"

import { useNavigate } from 'react-router-dom';



const Header = () => {

  const navigate = useNavigate()

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
      };


    function enviar(){
      navigate("/")
    }  


    return (
      <>
      <Location />
        <header className="bg-white-700 text-white relative">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center">
            {/* <Heart className="mr-2" /> */}
            <img src={Logo} onClick={enviar} className='w-1/2'/>
          </div>

          {/* Menu Hamburguer para Mobile */}
          <button 
            className="md:hidden z-50"
            onClick={toggleMenu}
          >
            {isMenuOpen ? <X size={24} color='#f94b1b' /> : <Menu size={24} color='#f94b1b' />}
          </button>

          {/* Menu Mobile */}
          <div className={`
            fixed inset-0 bg-white z-40 flex flex-col items-center justify-center
            transition-transform duration-300 ease-in-out
            md:hidden
            ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}
          `}>
            <div className="flex flex-col items-center space-y-8">
              <a href="#planos" 
                 onClick={toggleMenu}
                 className="text-2xl text-[#f94b1b]">
                Planos
              </a>
              <a href="#contato" 
                 onClick={toggleMenu}
                 className="text-2xl text-[#f94b1b]">
                Contato
              </a>
              <button className="bg-[#f94b1b] text-white px-6 py-3 rounded-lg text-xl font-semibold">
                Cotação Online
              </button>
            </div>
          </div>

          {/* Menu Desktop */}
          <div className="hidden md:flex items-center space-x-6">
            <a href="#planos" className="text-[#f94b1b]">Planos</a>
            <a href="#contato" className="text-[#f94b1b]">Contato</a>
            <button className="bg-[#f94b1b] text-white px-4 py-2 rounded-lg font-semibold hover:bg-blue-50">
              Cotação Online
            </button>
          </div>
        </div>
      </header>
      </>
    )
}

export default Header